module.exports = __webpack_public_path__ + "media/application/images/icons/location-2b188f11c03faf9056c1df9fd43ee89f.svg";